import styled from 'styled-components'
import { AnchorRecord, BlockRecordTypes, TableOfContentRecord } from 'types'

const StyledTableOfContents = styled.div`
  margin-top: 60px;
  margin-bottom: 60px;
  font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};

  ul.table-of-contents-items {
    list-style: none;
    padding-left: 0;

    li {
      padding-bottom: 16px;
    }
  }
`
const StyledHorizontalTableOfContents = styled.div`
  margin-top: 60px;
  margin-bottom: 60px;
  font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};

  ul.table-of-contents-items {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-left: 0;
    padding-left: 0;

    li {
      margin: 0 16px 20px 16px;
    }
  }
`

type PageContent = {
  value: any
  blocks: BlockRecordTypes[]
}

type TableOfContentsProps = {
  pageContent: PageContent
  record: TableOfContentRecord
}

const createNavigationElementsList = (pageContent: PageContent) => {
  const anchorRecords: AnchorRecord[] = pageContent.blocks.filter(
    (e) => e.__typename === 'AnchorRecord',
  ) as AnchorRecord[]

  return anchorRecords.map((element) => {
    return {
      id: element.id,
      title: element.navigationTitle,
      href: `#${element.sectionId}`,
    }
  })
}

export const TableOfContents = ({ pageContent, record }: TableOfContentsProps) => {
  const elements = createNavigationElementsList(pageContent)

  return record.showTableOfContent && elements ? (
    <>
      {record.horizontal ? (
        <StyledHorizontalTableOfContents>
          <ul className="table-of-contents-items">
            {elements.map((element) => {
              return (
                <li key={element.id}>
                  <a href={element.href}>{element.title}</a>
                </li>
              )
            })}
          </ul>
        </StyledHorizontalTableOfContents>
      ) : (
        <StyledTableOfContents>
          <h2>Table of Contents</h2>

          <ul className="table-of-contents-items">
            {elements.map((element) => {
              return (
                <li key={element.id}>
                  <a href={element.href}>{element.title}</a>
                </li>
              )
            })}
          </ul>
        </StyledTableOfContents>
      )}
    </>
  ) : null
}
